import { Default, Selected } from 'Molecules/Button/Variants/OptionButtons'

const OptionButton = ({ onClick, displayName, isSelected, classNames }) => {
  if (isSelected)
    return <Selected brand={'primary'} value={{ displayName }} testid={displayName} classNames={classNames} />
  return <Default value={{ displayName }} onClick={onClick} testid={displayName} classNames={classNames} />
}

export default OptionButton
